export default {
  primaryColor: '#172950',
  secondaryColor: '#ececec',
  appName: 'Example App',
  appTitle: 'An example title for app',
  showSocialLoginButtons: false
}